// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavWrapper_wrapper__2lw6C","logoWrapper":"NavWrapper_logoWrapper__2QZcL","logo":"NavWrapper_logo__3AEdS","channelStrip":"NavWrapper_channelStrip__mXE7o"};